// removed by extract-text-webpack-plugin
module.exports = {"header":"DesktopForm__header__1vgNe","form-container":"DesktopForm__form-container__1ENwH","scrollable":"DesktopForm__scrollable__1QN05","toggle-label":"DesktopForm__toggle-label__18IXE","label":"DesktopForm__label__d8VfV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CustomizedProposal/DesktopForm/DesktopForm.scss
// module id = 466
// module chunks = 0